import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'shared/modules/material/material.module';
import { RoutableModalComponent } from './routable-modal.component';

@NgModule({
  declarations: [RoutableModalComponent],
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
  ],
})
export class RoutableModalModule {
}
